// GrepResults.jsx — lista de matches do grep_search, agrupada por arquivo.
// Estilo Claude Code: arquivo como cabeçalho (accent), linha:nº tabular dim,
// trecho casado em mono. Input é o texto cru "file:line: trecho" (uma por
// linha), já vindo clampado do ToolCallBlock.

function parseMatches(text) {
  const groups = new Map();
  for (const raw of String(text || '').split('\n')) {
    const line = raw.trimEnd();
    if (!line) continue;
    // "path/to/file.js:42: const x = 1"  → file, lineNo, snippet
    const m = line.match(/^(.+?):(\d+):\s?(.*)$/);
    if (m) {
      const [, file, lineNo, snippet] = m;
      if (!groups.has(file)) groups.set(file, []);
      groups.get(file).push({ lineNo, snippet });
    } else {
      // linha solta (mensagem tipo "(sem resultados)") → bucket sem arquivo
      if (!groups.has('')) groups.set('', []);
      groups.get('').push({ lineNo: null, snippet: line });
    }
  }
  return [...groups.entries()];
}

export default function GrepResults({ text }) {
  const groups = parseMatches(text);
  if (!groups.length) {
    return <p className="px-3 py-2 font-mono text-[12px] text-apolo-textTertiary">(sem resultados)</p>;
  }
  return (
    <div className="divide-y divide-apolo-borderSubtle/60">
      {groups.map(([file, rows], gi) => (
        <div key={`${file}-${gi}`} className="px-3 py-1.5">
          {file && (
            <div className="mb-1 truncate font-mono text-[11px] font-medium text-apolo-accent" title={file}>
              {file}
            </div>
          )}
          <ul className="space-y-0.5">
            {rows.map((r, ri) => (
              <li key={ri} className="flex gap-2 font-mono text-[12px] leading-relaxed">
                {r.lineNo != null && (
                  <span className="shrink-0 select-none tabular-nums text-apolo-textTertiary/70">{r.lineNo}</span>
                )}
                <span className="min-w-0 whitespace-pre-wrap break-words text-apolo-textSecondary">{r.snippet}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
